import { NotFoundPage } from '~/components/common';
import {
  CallsPageAdmin,
  DashboardPageAdmin,
  ErrorLogsPageAdmin,
  FunnelPageAdmin,
  LocationPageAdmin,
  PermissionsPageAdmin,
  ProtectModePageAdmin,
  SafetyAlertsPageAdmin,
  SignInPageAdmin,
  SupportRequestsPageAdmin,
  UsersPageAdmin,
  RolesPageAdmin,
} from '~/pages/admin';
import { MyProfilePage } from '~/pages/account';
import { IRouteModel } from '../interface/common';

export interface IAdminRouteModel extends IRouteModel {
  // the staff-role feature (backend StaffFeatureEnum) that grants this page; none = every signed-in staff
  feature?: string;
  // only the super admin, never granted to staff (managing users and roles)
  superAdminOnly?: boolean;
  // false: reachable but not listed in the sidebar (e.g. the signed-in user's own profile)
  inNav?: boolean;
}

export const adminRoute = {
  base: '/admin',
  login: '/login',
  dashboard: '/dashboard',
  funnel: '/funnel',
  permissions: '/permissions',
  protectMode: '/protect-mode',
  calls: '/calls',
  location: '/location',
  safetyAlerts: '/safety-alerts',
  errorLogs: '/error-logs',
  supportRequests: '/support-requests',
  users: '/users',
  roles: '/roles',
  profile: '/profile',
};

export const publicAdminRoutes: IRouteModel[] = [
  {
    path: '*',
    component: NotFoundPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.login}`,
    component: SignInPageAdmin,
  },
];

// `name` holds an i18n key (nav.*) rather than display text - Sidebar renders it via t().
export const privateAdminRoutes: IAdminRouteModel[] = [
  {
    path: `${adminRoute.base}${adminRoute.dashboard}`,
    component: DashboardPageAdmin,
    name: 'nav.dashboard',
  },
  {
    path: `${adminRoute.base}${adminRoute.funnel}`,
    component: FunnelPageAdmin,
    name: 'nav.funnel',
    feature: 'FUNNEL',
  },
  {
    path: `${adminRoute.base}${adminRoute.permissions}`,
    component: PermissionsPageAdmin,
    name: 'nav.permissions',
    feature: 'PERMISSIONS',
  },
  {
    path: `${adminRoute.base}${adminRoute.protectMode}`,
    component: ProtectModePageAdmin,
    name: 'nav.protectMode',
    feature: 'PROTECT_MODE',
  },
  {
    path: `${adminRoute.base}${adminRoute.calls}`,
    component: CallsPageAdmin,
    name: 'nav.calls',
    feature: 'CALLS',
  },
  {
    path: `${adminRoute.base}${adminRoute.location}`,
    component: LocationPageAdmin,
    name: 'nav.location',
    feature: 'LOCATION',
  },
  {
    path: `${adminRoute.base}${adminRoute.safetyAlerts}`,
    component: SafetyAlertsPageAdmin,
    name: 'nav.safetyAlerts',
    feature: 'SAFETY_ALERTS',
  },
  {
    path: `${adminRoute.base}${adminRoute.errorLogs}`,
    component: ErrorLogsPageAdmin,
    name: 'nav.errorLogs',
    feature: 'ERROR_LOGS',
  },
  {
    path: `${adminRoute.base}${adminRoute.supportRequests}`,
    component: SupportRequestsPageAdmin,
    name: 'nav.supportRequests',
    feature: 'SUPPORT_REQUESTS',
  },
  {
    path: `${adminRoute.base}${adminRoute.users}`,
    component: UsersPageAdmin,
    name: 'nav.users',
    superAdminOnly: true,
  },
  {
    path: `${adminRoute.base}${adminRoute.roles}`,
    component: RolesPageAdmin,
    name: 'nav.roles',
    superAdminOnly: true,
  },
  {
    path: `${adminRoute.base}${adminRoute.profile}`,
    component: MyProfilePage,
    name: 'nav.profile',
    inNav: false,
  },
];

export const adminRouteAbsolute = {
  dashboard: `${adminRoute.base}${adminRoute.dashboard}`,
  funnel: `${adminRoute.base}${adminRoute.funnel}`,
  permissions: `${adminRoute.base}${adminRoute.permissions}`,
  protectMode: `${adminRoute.base}${adminRoute.protectMode}`,
  calls: `${adminRoute.base}${adminRoute.calls}`,
  location: `${adminRoute.base}${adminRoute.location}`,
  safetyAlerts: `${adminRoute.base}${adminRoute.safetyAlerts}`,
  errorLogs: `${adminRoute.base}${adminRoute.errorLogs}`,
  supportRequests: `${adminRoute.base}${adminRoute.supportRequests}`,
  users: `${adminRoute.base}${adminRoute.users}`,
  roles: `${adminRoute.base}${adminRoute.roles}`,
  profile: `${adminRoute.base}${adminRoute.profile}`,
};
